module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "import-airbnb-rentals-to-get-link",
      "aria-hidden": "false",
      "aria-labelledby": "exampleGrid",
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-simple modal-center",
    staticStyle: {
      "min-width": "730px"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#import-airbnb-rentals-to-get-link')
      }
    }
  }, [_c('span', {
    staticClass: "close-btn",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('p', {
    staticClass: "connection-link-description"
  }, [_vm._v("\n            Voici votre lien de connexion Airbnb :\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "connection-link-container"
  }, [_c('div', {
    staticClass: "link-display"
  }, [_c('span', {
    staticClass: "link-text"
  }, [_vm._v(_vm._s(_vm.link))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-outline-primary copy-link-btn waves-effect waves-classic",
    attrs: {
      "type": "button",
      "disabled": !_vm.link
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.copyLinkToClipboard($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-copy"
  }), _vm._v(" Copier\n              ")])])])])]), _vm._v(" "), _c('v-loading', {
    attrs: {
      "isLoading": _vm.loading,
      "height": 50,
      "width": 50,
      "viewbox": '0 0 50 50',
      "cx": 25,
      "cy": 25,
      "r": 22,
      "isHeightAuto": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn waves-effect waves-classic btn-cancel",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#import-airbnb-rentals-to-get-link')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('button.close') || 'Fermer') + "\n        ")])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-8"
  }, [_c('h4', {
    staticClass: "modal-title text-left"
  }, [_vm._v("Lien de connexion Airbnb")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b789af0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/account/settings/modals/ImportNewAirbnbRentalsToGetLink.vue
// module id = 1427
// module chunks = 0